/* eslint-disable */
import { useContext, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Header, Container, ExportReportWrapper } from '../../styles/shared/styles';
import { MainContext } from '../../context/ApiContext';
import Box from '@material-ui/core/Box';
import DatePeriodFilter from '../../components/DiagnosisReportTableList/Filter';
import SummaryReport from '../../components/DiagnosisReportTableList/SummaryReport';
import LoadingPage from '../LoadingPage';
import useApp from '../../hooks/useApp';
import useSWR from 'swr';
import { fetcher } from '../../service/SWRFetcher';
import { DateTime } from 'luxon';
import { TablePagination } from '@material-ui/core';
import { listToMatrix } from '../../utils/array';
import { pdfExport } from '../../service/pdf.service';
import { toast } from 'react-toastify';

const DiagnosisReport = () => {
  const { setState } = useApp();
  const dateNow = DateTime.now().toISODate();
  const dateLastMonth = DateTime.now().plus({ months: -1 }).toISODate();
  const [filters, setFilters] = useState({
    date_ini: dateLastMonth,
    date_end: dateNow,
    broker_id: '',
    technical_team: '',
  });

  const brokerFilter = () => {
    if (!filters.broker_id || filters.broker_id.length === 0) return '';

    let stringBrokerFilter = '';
    filters.broker_id.map((b) => (stringBrokerFilter += `&broker_id[]=${b.id}`));
    return stringBrokerFilter;
  };

  const getChannelFromTechTeam = () => {
    if (!filters.technical_team || filters.technical_team.length === 0) return '';

    const renovationChannels = filters.technical_team.channels.filter((channel) => channel.id > 26 && channel.id < 30);

    let stringChannelFilter = '';
    renovationChannels.map((c) => (stringChannelFilter += `&channel_id[]=${c.id}`));
    return stringChannelFilter;
  };

  const { data, mutate, isValidating } = useSWR(
    `/diagnosis?start_date=${filters.date_ini}&end_date=${filters.date_end}&broker_id=${
      filters?.broker_id
    }&technicalTeam=${filters?.technical_team?.id}`,
    fetcher,
    { revalidateOnFocus: false }
  );

  const handleExportPdf = (e) => {
    e.preventDefault();
    if (data && !data?.items?.count_leads) {
      return toast.error('Não há leads para exportar nesse período!');
    }

    pdfExport(
      `/diagnosisRenew/diagnosisRenewReportExport?technicalTeam=${filters?.technical_team?.id}&start_date=${filters.date_ini}&end_date=${
        filters.date_end
      }&broker_id=${filters?.broker_id}`,
      'relatorio_diagnostico_renov_' + DateTime.now().toFormat('dd_LL_yyyy')
    );
  };

  useEffect(() => {
    setState('loading', isValidating);
  }, [isValidating]);

  return (
    <motion.div initial={{ opacity: 0, x: -100 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -100 }}>
      <Container style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <Header>
          <h1>Diagnóstico de Venda de Seguros de Renovação</h1>
        </Header>

        <DatePeriodFilter filters={filters} setFilters={setFilters} />

        {!!data && <SummaryReport dataItems={data} />}

        <ExportReportWrapper>
          <button className="button" onClick={handleExportPdf}>
            Exportar
          </button>
        </ExportReportWrapper>
      </Container>
    </motion.div>
  );
};

export default DiagnosisReport;
